import Component from "../Component";
import Page from "../../pages/Page";
import "../../globals";
import { getApi } from "../../auth";
import * as validation from "~/utils/validation";
import UI from "../../ui";
import $ from "jquery";
import { t } from "~/hooks/useI18n";

import { domSelectors } from "../../globals";
import { gotoDefault, gotoHome, gotoLogin } from "~/utils";
import * as bootstrap from "bootstrap";

import { uploadDocumentoUtente } from "~/services/documentService";


// ✅ Importa utility validazione file
import {
    ALLOWED_FILE_EXTENSIONS,
    validateAndShowFileError,
    formatFileSize,
    showFileError,
    clearFileError,
    showCustomFileError,
    clearCustomFileError,
    validateMaskedFileInputWithBorder
} from "~/utils/fileValidation";

class DocumentoModal extends Component {
    private theForm: HTMLFormElement = document.getElementById("frmDocumentoUtente") as HTMLFormElement;
    private modalDocumento: HTMLElement = document.getElementById("modalCaricaDocumentoUtente") as HTMLElement;
    private onSuccessCallback: (() => void) | null = null;
    // ✅ Aggiungi flag per tracciare lo stato di invio del form info scheda
    private isSubmitting: boolean = false;
    private _eventsRegistered: boolean = false; //evita la registrazione multipla degli eventi sulla stessa istanza della modale

    constructor(containerId: string, formId: string) {
        super(containerId);
        this.theForm = document.getElementById(formId) as HTMLFormElement;
        if (!this.theForm) {
            console.error(`Form con ID '${formId}' non trovato.`);
        }
    }

    public setOnSuccessCallback(callback: () => void): void {
        this.onSuccessCallback = callback;
    }

    public async activate(): Promise<void> {
        const that = this; // Cattura il valore di 'this'
        that.addValidation();

        // ✅ Sposta la modale come figlio diretto di <body> per evitare che finisca
        // "intrappolata" nello stacking context di contenitori antenati con
        // position:relative + z-index (es. .container.position-relative.z-2),
        // che altrimenti farebbero apparire il .modal-backdrop sopra la modale
        // impedendo l'interazione con il form.
        if (this.modalDocumento && this.modalDocumento.parentElement !== document.body) {
            document.body.appendChild(this.modalDocumento);
        }

        if (!this._eventsRegistered) {
            // Registra gli event handlers
            this.registerEventHandlers();
            this._eventsRegistered = true;
            const btnUploadDoc = $(this.domElement).find("#btnCaricaDocumentoUtente");

            if (btnUploadDoc.length === 0) {
                console.error("Pulsante upload documento non trovato");
                return;
            }

            // Aggiungi listener al pulsante
            btnUploadDoc.on("click", (event) => {
                event.preventDefault();

                if (that.isSubmitting) {
                    console.warn("Invio già in corso, ignoro il click");
                    return false;
                }

                that.handleFormSubmit();
                return false;
            });
        }
        return Promise.resolve();
    }

    private addValidation(): void {
        const form = this.theForm;

        // Rimuove la classe di validazione quando l'utente modifica i campi
        form.addEventListener("input", () => {
            form.classList.remove("was-validated");

            // ✅ Pulisci gli errori dei file quando l'utente modifica qualsiasi campo
            const fileInputFronte = document.getElementById("txtFileFronte") as HTMLInputElement;
            const fileInputRetro = document.getElementById("txtFileRetro") as HTMLInputElement;

            if (fileInputFronte) {
                clearFileError(fileInputFronte);
            }
            if (fileInputRetro) {
                clearFileError(fileInputRetro);
            }
        });

        // Validatore per il file
        const fileValidator = (inputElement: HTMLInputElement): validation.ValidationResult => {
            const file = inputElement.files && inputElement.files[0];
            const isValid = !!file && file.size > 0; // Assegna un valore booleano a isValid

            return {
                ok: isValid,
                error: isValid ? "" : t("validation.required")
            };
        };

        const validaFileFronte = () => {
            validation.validate("txtFileFronte", fileValidator);
        }


        validation.setValidatorOnInput("txtFileFronte", fileValidator);

        // Validazione al submit
        this.onSubmitValidator = async () => {
            const fileInputRetro = document.getElementById("txtFileRetro") as HTMLInputElement;
            if (fileInputRetro) {
                clearFileError(fileInputRetro);
            }
            
            validaFileFronte();

            // Scorri al primo errore
            const firstInvalidElement = form.querySelector(".is-invalid");
            if (firstInvalidElement) {
                firstInvalidElement.scrollIntoView({ behavior: "smooth", block: "center" });
                (firstInvalidElement as HTMLElement).focus();
            }
        };

    }

    private registerEventHandlers(): void {
        const that = this;

        // ✅ Validazione file al momento della selezione
        $("#txtFileFronte").on("change", function () {
            const fileInput = this as HTMLInputElement;
            // ✅ Pulisci eventuali errori precedenti prima di validare
            clearFileError(fileInput);
            if (fileInput.files && fileInput.files.length > 0) {
                validateAndShowFileError(fileInput, fileInput.files[0]);
            }
        });

        $("#txtFileRetro").on("change", function () {
            const fileInput = this as HTMLInputElement;
            // ✅ Pulisci eventuali errori precedenti prima di validare
            clearFileError(fileInput);
            if (fileInput.files && fileInput.files.length > 0) {
                validateAndShowFileError(fileInput, fileInput.files[0]);
            }
        });

        // ✅ Reset form alla chiusura della modale
        $(this.modalDocumento).on("hidden.bs.modal", function () {
            that.resetForm();
        });
    }

    /**
 * ✅ Reset completo del form e rimozione validazioni
 */
    private resetForm(): void {
        const formElement = this.theForm;

        if (formElement) {
            // Reset di tutti i campi
            formElement.reset();
            // Rimuove la classe di validazione
            formElement.classList.remove("was-validated");

            // Nasconde tutti i messaggi di errore personalizzati
            const invalidFeedback = formElement.querySelectorAll(".invalid-feedback");
            invalidFeedback.forEach((feedback) => {
                feedback.classList.add("d-none");
            });

            // Rimuove la classe is-invalid da tutti gli input
            const invalidInputs = formElement.querySelectorAll(".is-invalid");
            invalidInputs.forEach((input) => {
                input.classList.remove("is-invalid");
            });

            // ✅ Pulisce eventuali errori di validazione file
            const fileInputFronte = document.getElementById("txtFileFronte") as HTMLInputElement;
            const fileInputRetro = document.getElementById("txtFileRetro") as HTMLInputElement;

            clearFileError(fileInputFronte);
            clearCustomFileError(fileInputFronte); // ✅ Aggiunto per messaggi custom
            clearFileError(fileInputRetro);
            clearCustomFileError(fileInputRetro); // ✅ Aggiunto per messaggi custom

            // ✅ Reset flag di invio
            this.isSubmitting = false;
        }
    }

    private onSubmitValidator: () => void = async () => {
    }

    private async handleFormSubmit(): Promise<void> {
        this.onSubmitValidator();
        if (!this.theForm.checkValidity()) {
            this.theForm.classList.add('was-validated');
            return;
        }

        // ✅ Imposta la flag e disabilita il pulsante
        this.isSubmitting = true;
        const $btnSubmit = $("#btnCaricaDocumentoUtente");
        const originalText = $btnSubmit.html();

        // ✅ Mostra feedback visivo
        $btnSubmit.prop("disabled", true).html(`<span class="spinner-border spinner-border-sm me-2"></span>${t("common.salvataggioInCorso")}`);

        try {
            // Aggiungi i file caricati
            const fileInputFronte = document.getElementById("txtFileFronte") as HTMLInputElement;
            const fileInputRetro = document.getElementById("txtFileRetro") as HTMLInputElement;

            const auth = getApi();
            const userinfo = auth.getCached("userInfo");

            if (!userinfo || !userinfo.isAuthenticated || !userinfo.anagraficaId) {
                console.error("Utente non autenticato");
                return;
            }

            const userId = userinfo.anagraficaId;

            // Recupera i valori dagli input
            const tipoDocumento = (document.getElementById("cboTipoDocumentoUtente") as HTMLSelectElement).value;
            const numero = (document.getElementById("txtNumero") as HTMLInputElement).value;
            const enteRilascio = (document.getElementById("txtEnteRilascio") as HTMLInputElement).value;
            const scadenza = (document.getElementById("txtDataScadenza") as HTMLInputElement).value;

            if (!fileInputFronte.files?.[0]) {
                console.error("File fronte non selezionato");
                return;
            }

            const data = {
                UserId: Number(userId),
                TipoDoc: tipoDocumento,
                Numero: numero,
                EnteRilascio: enteRilascio,
                Scadenza: new Date(scadenza),
                FileFronte: fileInputFronte.files[0],
                FileRetro: fileInputRetro.files?.[0],
            };

            const result: any = await uploadDocumentoUtente(data);

            if (!result) {
                console.error("Errore nel caricamento del documento");
                UI.confirmOneButton("", t("messages.errCaricamentoDocumento") + result.message);
            }

            const documento = result.data.Allegato;
            console.info("docuemnto di Identità:", documento.Id);

            const documentiDiv = document.getElementById("documentiAnagrafica");


            if (documentiDiv) {
                const nuovoDocumentoHtml = `
            <div class="border rounded bg-secondary-subtle pt-2 pb-1 mb-3 position-relative overflow-hidden">
                <div class="bg-white rounded shadow-sm">
                    <div class="d-flex flex-column flex-sm-row">
                        <div class="border-bottom border-sm-bottom-0 border-sm-end p-4 flex-grow-1 position-relative overflow-hidden">
                            <div class="position-absolute ${this.isDocumentoScaduto(documento.Scadenza) ? "" : "d-none"}" style="right:-40px;top:32px">
                                <div class="rotate--45">
                                    <div class="fs-7 text-uppercase text-white fw-bold bg-primary py-1 px-5">${t("common.scaduto")}</div>
                                </div>
                            </div>
                            <div class="d-flex">
                                <h2 class="h6 fw-bold">${documento.Tipo.Descrizione}</h2>
                                <a href="/AreaRiservata/ScaricaDocumentoUtente?data=${documento.Path}" target="_blank" class="text-body">
                                    <span class="material-symbols-outlined">download</span>
                                </a>
                            </div>
                            <div class="small">
                                <strong>${t("common.rilasciatoDa")}:</strong> ${documento.EnteRilascio}
                            </div>
                            <div class="small">
                                <strong>${t("common.numero")}:</strong> ${documento.Numero}
                            </div>
                        </div>
                        <div class="d-flex flex-column justify-content-center align-content-center p-4">
                            <span class="d-block small">${t("common.scadenza")}</span>
                            <span class="d-block fs-5 fw-bold ${this.isDocumentoScaduto(documento.Scadenza) ? "text-primary" : ""}">${UI.formatDateIsoToIt(documento.Scadenza)}</span>
                        </div>
                    </div>
                </div>
            </div>
        `;
                documentiDiv.insertAdjacentHTML("afterbegin", nuovoDocumentoHtml);
                $("#div-nessun-documento").addClass("d-none");
            }


            // ✅ Chiudi la modale dopo il successo
            const modal = bootstrap.Modal.getInstance(this.modalDocumento);
            modal?.hide();

            UI.confirmOneButton("", t("messages.msgDocumentoCaricatoConSuccesso"));


        } catch (error) {
            console.error(error);
        } finally {
            this.isSubmitting = false;
            $btnSubmit.html(originalText).removeAttr("disabled");
        }
    }

    private isDocumentoScaduto(scadenza: string | Date): boolean {
        const dataScadenza = new Date(scadenza);
        const oggi = new Date();

        // Confronta solo le date, non l'orario
        dataScadenza.setHours(0, 0, 0, 0);
        oggi.setHours(0, 0, 0, 0);

        return dataScadenza < oggi;
    }

    private convertDateString(dateString: string): string {
        // Estrai il timestamp dalla stringa
        const timestamp = parseInt(dateString.replace('/Date(', '').replace(')/', ''));

        // Crea un oggetto Date utilizzando il timestamp
        const date = new Date(timestamp);

        // Estrai giorno, mese e anno
        const day = date.getUTCDate().toString().padStart(2, '0');
        const month = (date.getUTCMonth() + 1).toString().padStart(2, '0'); // I mesi sono indicizzati da 0
        const year = date.getUTCFullYear();

        // Ritorna la data formattata come gg/MM/yyyy
        return `${day}/${month}/${year}`;
    }

    private convertStringInDate(dateString: string): Date {
        // Estrai il timestamp dalla stringa
        const timestamp = parseInt(dateString.replace('/Date(', '').replace(')/', ''));

        // Crea un oggetto Date utilizzando il timestamp
        const data = new Date(timestamp);

        // Ritorna la data in stringa in Date UTC
        return data;
    }

    //private checkDocumentoUtente(userId: number)
    public async checkDocumentoUtente(userId: number): Promise<boolean> {
        console.info(userId);
        const auth = getApi();
        try {
            const data = await auth.fetchWithAuth(
                `GET ${window.BaseUrlWebApi}UserProfile/CheckDocumentoUtente?userId=${userId}`
            );
            return data;
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
}

export default DocumentoModal;